import { NgxFullpageToFirstButtonDirective } from './top-button/ngx-fullpage-to-first-button.directive';
import { NgModule } from '@angular/core';



@NgModule({
  declarations: [NgxFullpageToFirstButtonDirective],
  imports: [],
  exports: [NgxFullpageToFirstButtonDirective],
})
export class NgxFullpageToFirstButtonModule { }
